//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'HSCCF',
  data() {
    return {
      defaultJson:{
        "Serum sodium concentration": "血清钠浓度",
        "Serum glucose concentration": "血清葡萄糖浓度",
        "Corrected sodium concentration (Katz, 1973)": "校正的钠浓度(Katz，1973)",
        "Corrected sodium concentration (Hillier, 1999)": "校正的钠浓度(Hillier，1999)"
      },
      form:{
        ssc:'',
        sgc:''
      },
      hasScore:false,
      disabled:false,
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key]=='---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '...'
      } else {
        console.log(form)
        let Katz = form.ssc + +[1.6 * (form.sgc - 5.5) / 5.5]
        let Hillier = form.ssc + +[2.4 * (form.sgc - 5.5) / 5.5]
        self.hasScore = true
        return {
          csc_Katz: Katz.toFixed(0),
          csc_Hillier: Hillier.toFixed(0)
        }
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Endocrine/HSCCF.vue